import { Button } from "antd"
import Link from "next/link"
import { URL_TEMPLATE } from "src/libs/constant"

const HeaderRemindTutor = () => {
  return (
    <>
      <div className='d-flex align-items-center'>
        <div className='header-layout__title'>
          <h4>Lịch dạy hôm nay</h4>
          <div>
            <p className='header-description'>
              Chuẩn bị bài trước buổi học và "Nhắc nhở
            </p>
            <p className='header-description'>
              HS lớp Regular (Buổi 1) làm BÀI TẬP NÓI"
            </p>
          </div>
        </div>
        <div className='header-layout__description'>
          <ul className='pl-2'>
            <li className='header-layout__description'>Xem nhanh lịch dạy </li>
            <li className='header-layout__description'>Xem bài tập về nhà</li>
          </ul>
          <ul>
            <li className='header-layout__description'>Xem thông tin buổi học</li>
            <li className='header-layout__description'>Xem nội dung bài giảng</li>
          </ul>
        </div>
        <Link href={`${URL_TEMPLATE.SESSION_TEACHING_SCHEDULE}`}>
          <button className='header-button__use-immediately'>
            Dùng ngay
          </button>
        </Link>
      </div>
    </>
  )
}

export default HeaderRemindTutor
